export const endpoints = {
  findAll: '/contact/findAll/:accountId',
}
